import React from 'react';

function Team() {
  return (
    <section className="team-single">
      <div className="container-fluid">
        <div className="row xlg-marg">
          <div className="col-lg-6">
            <div className="img">
              <img
                src="/light/assets/imgs/team/t5.jpg"
                alt=""
                data-speed="0.2"
                data-lag="0"
              />
            </div>
          </div>
          <div className="col-lg-6 valign">
            <div className="cont">
              <h1>David Miller</h1>
              <h6 className="text-u ls1 opacity-8">
                Project manager & ART director
              </h6>
              <div className="text main-bg">
                <p className="main-text">
                  Pink salmon cherry salmon combtail gourami frigate mackerel
                  snake mackerel upside-down catfish finback cat shark. Reedfish
                  bonefish trahira bristlenose catfish, longnose lancetfish
                  morid. Wahoo mora deep sea smelt cat shark.
                </p>
                <div className="row md-marg mt-40">
                  <div className="col-sm-6">
                    <p>
                      Pink salmon cherry salmon combtail gourami frigate
                      mackerel snake mackerel upside-down catfish finback cat
                      shark. Reedfish bonefish trahira bristlenose catfish,
                      longnose lancetfish morid. Wahoo mora deep sea smelt cat
                      shark.
                    </p>
                  </div>
                  <div className="col-sm-6">
                    <p>
                      Pink salmon cherry salmon combtail gourami frigate
                      mackerel snake mackerel upside-down catfish finback cat
                      shark. Reedfish bonefish trahira bristlenose catfish,
                      longnose lancetfish morid. Wahoo mora deep sea smelt cat
                      shark.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
